document.addEventListener('DOMContentLoaded', function () {
  const productSingleSwipers = document.querySelectorAll('.product-single-swiper.swiper');
  if (productSingleSwipers.length >= 1) {
    productSingleSwipers.forEach(function (productSingleSwiper) {
      let thumbsElement = productSingleSwiper.nextElementSibling;
      const thumbsSwiper = new Swiper(thumbsElement, {
        slidesPerView: 'auto',
        direction: 'vertical',
        spaceBetween: 12,
        breakpoints: {
          640: {
            spaceBetween: 14,
          },
          1025: {
            spaceBetween: 16,
          },
        },
        on: {
          click() {
            thumbsSwiper.slideTo(this.clickedIndex);
          },
        },
      });
      const swiper = new Swiper(productSingleSwiper, {
        slidesPerView: 1,
        thumbs: {
          swiper: thumbsSwiper,
        },
      });
    });
  }
  // dynamic slider
  const dynamicSwipers = document.querySelectorAll('.dynamic-swiper.swiper');
  if (dynamicSwipers.length) {
    dynamicSwipers.forEach(function (dynamicSwiper) {
      if (!dynamicSwiper.dataset.mobile_slides_per_view) dynamicSwiper.dataset.mobile_slides_per_view = 'auto';
      const mobileFreeMode = dynamicSwiper.dataset.mobile_slides_per_view === 'auto';
      const mobileSlidesPerView = mobileFreeMode ? 'auto' : parseInt(dynamicSwiper.dataset.mobile_slides_per_view);
      if (!dynamicSwiper.dataset.desktop_slides_per_view) dynamicSwiper.dataset.desktop_slides_per_view = 'auto';
      const desktopFreeMode = dynamicSwiper.dataset.desktop_slides_per_view === 'auto';
      const desktopSlidesPerView = desktopFreeMode ? 'auto' : parseInt(dynamicSwiper.dataset.desktop_slides_per_view);

      let swiperNext = dynamicSwiper.querySelector('.swiper-next');
      let swiperPrev = dynamicSwiper.querySelector('.swiper-prev');
      const swiper = new Swiper(dynamicSwiper, {
        slidesPerView: mobileSlidesPerView,
        freeMode: mobileFreeMode,
        spaceBetween: 12,
        observer: true,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },
        navigation: {
          nextEl: swiperNext,
          prevEl: swiperPrev,
        },
        breakpoints: {
          640: {
            spaceBetween: 14,
          },
          1024: {
            freeMode: desktopFreeMode,
            slidesPerView: desktopSlidesPerView,
            spaceBetween: 16,
          },
        },
      });
    });
  }

  let accordions = document.querySelectorAll('.alt-accordion');
  if (accordions.length >= 1) {
    accordions.forEach(function (accordion) {
      let header = accordion.querySelector('.alt-accordion-header');
      let content = accordion.querySelector('.alt-accordion-content');
      let expandIcon = accordion.querySelector('.expand-icon');
      let contractIcon = accordion.querySelector('.contract-icon');

      header.addEventListener('click', function () {
        if (content.classList.contains('content-visible')) {
          /* gsap.to(content, {
            height: 0,
            duration: 0.25,
            onComplete: function () {
              content.classList.remove('content-visible');
            },
          }); */
          content.style.height = 0;
          content.classList.remove('content-visible');
          contractIcon.classList.add('hidden');
          expandIcon.classList.remove('hidden');
        } else {
          /* gsap.to(content, {
            height: 'auto',
            duration: 0.25,
            onComplete: function () {
              content.classList.add('content-visible');
            },
          }); */
          content.style.height = 'auto';
          content.classList.add('content-visible');
          contractIcon.classList.remove('hidden');
          expandIcon.classList.add('hidden');
        }
      });
    });
  }

  // Handle dropdown toggle functionality
  const dropdownHeaders = document.querySelectorAll('.variant-dropdown-header');

  // Click outside handler
  function handleClickOutside(event) {
    const activeDropdowns = document.querySelectorAll('.variant-dropdown.active');

    activeDropdowns.forEach((dropdown) => {
      const content = dropdown.querySelector('.variant-dropdown-content');
      const icon = dropdown.querySelector('svg');

      // Check if click is outside the dropdown
      if (!dropdown.contains(event.target)) {
        dropdown.classList.remove('active');
        content.classList.replace('overflow-auto', 'overflow-hidden');
        /* gsap.to(content, {
          height: 0,
          duration: 0.25,
          onComplete: function () {
            content.classList.remove('border-t', 'border-b');
          },
        }); */
        content.style.height = 0;
        content.classList.remove('border-t', 'border-b');
        if (icon) icon.classList.remove('rotate-180');
      }
    });
  }

  dropdownHeaders.forEach((header) => {
    const dropdown = header.closest('.variant-dropdown');
    const content = dropdown.querySelector('.variant-dropdown-content');

    header.addEventListener('click', function (e) {
      e.stopPropagation(); // Prevent triggering the outside click immediately

      const isActive = dropdown.classList.contains('active');
      const icon = dropdown.querySelector('svg');
      // Close all other open dropdowns first
      document.querySelectorAll('.variant-dropdown.active').forEach((openDropdown) => {
        if (openDropdown !== dropdown) {
          openDropdown.classList.remove('active');
          const openContent = openDropdown.querySelector('.variant-dropdown-content');
          const openIcon = openDropdown.querySelector('svg');
          openContent.classList.replace('overflow-auto', 'overflow-hidden');
          /* gsap.to(openContent, {
            height: 0,
            duration: 0.25,
            onComplete: function () {
              openContent.classList.remove('border-t', 'border-b');
            },
          }); */
          openContent.style.height = 0;
          openContent.classList.remove('border-t', 'border-b');
          if (openIcon) openIcon.classList.remove('rotate-180');
        }
      });

      // Toggle current dropdown
      if (isActive) {
        dropdown.classList.remove('active');
        content.classList.replace('overflow-auto', 'overflow-hidden');
        /* gsap.to(content, {
          height: 0,
          duration: 0.25,
          onComplete: function () {
            content.classList.remove('border-t', 'border-b');
          },
        }); */
        content.style.height = 0;
        content.classList.remove('border-t', 'border-b');
        if (icon) icon.classList.remove('rotate-180');
      } else {
        dropdown.classList.add('active');
        /* gsap.to(content, {
          height: 'auto',
          duration: 0.25,
          onComplete: function () {
            content.classList.replace('overflow-hidden', 'overflow-auto');
          },
        }); */
        content.style.height = 'auto';
        content.classList.replace('overflow-hidden', 'overflow-auto');
        content.classList.add('border-t', 'border-b');
        if (icon) icon.classList.add('rotate-180');
      }
    });

    // replace dropdown label
    const dropdownLabel = header.querySelector('.variant-dropdown-label');
    if (dropdownLabel) {
      const dropdownOptions = content.querySelectorAll('.variant-dropdown-option');
      dropdownOptions.forEach((option) => {
        const optionLabel = option.parentElement.querySelector('.variant-dropdown-option-label');
        option.addEventListener('click', () => {
          dropdownLabel.innerHTML = optionLabel.innerHTML;
        });
      });
    }
  });

  // Add click listener to document
  document.addEventListener('click', handleClickOutside);
});
